import { useEffect } from 'react';

import { useAssistant } from './store';

/**
 * Register the current route entity with the floating assistant so its
 * retrieval is scoped to this object (Wave 10).
 *
 *   useAssistantEntity({
 *     entity: 'crm.deal',
 *     entity_id: String(deal.id),
 *     label: `Deal: ${deal.title}`,
 *   });
 *
 * Pass `null` to clear (e.g. while a fetch is loading and the label is empty).
 * The hook clears the context on unmount so navigating away resets the panel.
 */
export function useAssistantEntity(
  context: { entity: string; entity_id: string; label: string } | null,
): void {
  const setEntity = useAssistant((s) => s.setEntity);

  // Stringify the value into a stable dep so identity changes on the object
  // literal don't churn — only real value changes re-register.
  const key = context ? `${context.entity}|${context.entity_id}|${context.label}` : '';

  useEffect(() => {
    setEntity(context);
    return () => setEntity(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- depend on the value-key, not the object identity
  }, [key, setEntity]);
}
